import React from "react";
import { Grid, Section, BreadCrumbBox } from "../../core";
import CompanyDispatchHistory from "../../components/CompanyDispatchHistory";
import { updateCurrentPath } from "../../redux/Action/pageRoot";
import { useDispatch } from "react-redux";

const DispatchList = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(updateCurrentPath("Dispatch List"));
  }, [dispatch]);

  return (
    <Grid>
      <BreadCrumbBox tittle="Dispatch List" route="/contract-list" />
      <Section>
        <Grid>
          <CompanyDispatchHistory />
        </Grid>
      </Section>
    </Grid>
  );
};

export default DispatchList;
